import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { reducer as formReducer } from 'redux-form'

import dialogueBox from './components/DialogueBox/reducer';
import {changeWorkkardOwner, changeActivityOwner } from './components/ChangeOwner/reducer';
import activityAssigneeCompData from './components/ChangeActivityAssignee/reducer'
import isLoading from './components/AppLoader/reducer';
import workkardDetail from './containers/WorkkardDetail/reducers';
import tooltip from './components/Tooltip/reducer';
import validationError from './common/reducers/errorValidationMessage';
import toast from './components/Toast/reducer';
import rightPopUpComponent from "./components/RightPopUpComponent/reducer";
import header from "./containers/Header/reducers";
// import sessionContext from './common/reducers/sessionContext';
import sessionContextOidc from './common/reducers/sessionContextOidc';
import navigation from './common/slice/navigation';
import userList from './common/slice/userList';
import orgList from './common/slice/orgList';
import workkardListing from './containers/WorkkardListing/slice';
import activityListing from './containers/ActivityListing/slice';
import headerContext from './common/reducers/headerContext';
import diaryCreation from './containers/CreationForms/DiaryCreation/reducers';
import activityCreation from './containers/CreationForms/ActivityCreation/reducers';
import diaries from './containers/Diaries/reducers';
import appError from './common/reducers/appError';
import adminPanel  from './containers/AdminPanel/reducers';
import websocket from './common/reducers/websocket';
import liveUpdates from './common/slice/liveUpdates';
import activityFormReducer from "./containers/CreationForms/AddEditActivity/store/activityFormSlice";
import activitySkillsetTagsReducer from "./containers/CreationForms/AddEditActivity/store/skillsetTagsSlice";
import activityAssignmentMethodReducer from "./containers/CreationForms/AddEditActivity/store/assignmentMethodSlice";
import workkardForm from './containers/CreationForms/AddEditWorkkard/store/workkardFormSlice';
 

export default combineReducers({
    changeWorkkardOwner,
    changeActivityOwner,
    dialogueBox,
    loadingBar: loadingBarReducer,
    workkardDetail,
    tooltip,
    isLoading,
    activityAssigneeCompData,
    validationError,
    toast,
    rightPopUpComponent,
    header,
    sessionContextOidc,
    navigation,
    userList,
    orgList,
    workkardListing,
    activityListing,
    headerContext,
    form: formReducer,
    diaryCreation,
    diaries,
    appError,
    activityCreation,
    adminPanel,
    websocket,
    liveUpdates,
    activityForm: activityFormReducer,
    workkardForm,
    activitySkillsetTags: activitySkillsetTagsReducer,
    activityAssignmentMethod: activityAssignmentMethodReducer,
});
